import React from 'react'
import styled from 'styled-components'
import { Icon } from '../../../atoms/Icon'

const LocationFAB = styled.button<{ $position: string }>`
  position: absolute;
  ${({ $position }) => {
    switch ($position) {
      case 'top-left':
        return 'top: 24px; left: 16px;'
      case 'top-right':
        return 'top: 24px; right: 16px;'
      case 'bottom-left':
        return 'bottom: 24px; left: 16px;'
      case 'bottom-right':
        return 'bottom: 24px; right: 16px;'
      default:
        return 'bottom: 24px; right: 16px;'
    }
  }}
  width: 40px;
  height: 40px;
  background: white;
  border: none;
  border-radius: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2;
  color: var(--text-primary, #1a1a1a);

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    bottom: 16px;
    right: 8px;
  }
`

interface MapLocationFABProps {
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  onClick?: () => void
  title?: string
}

export const MapLocationFAB: React.FC<MapLocationFABProps> = ({
  position = 'bottom-right',
  onClick,
  title = 'Fly to my location',
}) => {
  return (
    <LocationFAB
      $position={position}
      onClick={onClick}
      title={title}
      aria-label={title}
    >
      <Icon name="crosshair" size="medium" />
    </LocationFAB>
  )
}
